import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useMemo, useState} from 'react';

import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsDrawerSection} from './MediaSettingsDrawerSection';
import {getMediaSettingsTabs} from './util';

export const MediaSettingsDrawerContent = () => {
  const {mediaCardType, config, hasMasks, hasBoundingBoxes, rampFlags} =
    useMediaSettingsDrawerContext();
  const tabs = useMemo(
    () =>
      getMediaSettingsTabs(
        mediaCardType,
        config,
        hasMasks,
        hasBoundingBoxes,
        rampFlags
      ),
    [mediaCardType, config, hasMasks, hasBoundingBoxes, rampFlags]
  );
  const [selectedTab, setSelectedTab] = useState<string | undefined>(
    tabs?.[0]?.title
  );
  return (
    <SettingsContentWrapper
      title="Media settings"
      description="Customize settings for media in this panel."
      header={
        <h2 className="text-sm font-semibold leading-[22px] text-moon-500">
          PANEL SETTINGS
        </h2>
      }>
      <Tabs.Root value={selectedTab ?? ''} onValueChange={setSelectedTab}>
        <Tabs.List>
          {tabs.map(({title}) => (
            <Tabs.Trigger key={title} data-test={title} value={title}>
              {title}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {selectedTab && (
          <Tabs.Content value={selectedTab}>
            <div className="py-24" data-test="media-settings-drawer-content">
              {tabs
                .find(tab => tab.title === selectedTab)
                ?.sections.map(section => (
                  <MediaSettingsDrawerSection
                    key={section.title}
                    {...section}
                  />
                ))}
            </div>
          </Tabs.Content>
        )}
      </Tabs.Root>
    </SettingsContentWrapper>
  );
};
